import { useState } from 'react';
import { useDeleteNotificationRule } from '../../../hooks/queries/logQueries';
import CloseIcon from '../../../assets/icons/close.svg?react';
import TargetIcon from '../../../assets/icons/target.svg?react';
const AlertSetUpDeleteModal = ({ onClose, target, onSuccess }) => {
  const deleteNotificationRule = useDeleteNotificationRule();
  const [isPending, setIsPending] = useState(false);
  const handleDelete = async () => {
    setIsPending(true);
    try {
      await deleteNotificationRule.mutateAsync(target.NotificationRuleSysId);
      onSuccess();
    } catch (error) {
      console.error('알림 설정 삭제 실패:', error);
      alert('알림 설정 삭제에 실패했습니다.');
    } finally {
      setIsPending(false);
    }
  };
  return (
    <div className="modal-background">
      <div className="modal-container alert-setup-delete-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>알림 규칙 삭제</h3>
          <button className="close-btn" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="modal-content">
          <p className="text-b2-400 text-gray-800 my-10">알림 규칙을 삭제하시겠습니까?</p>
          <table className='gray-table'>
            <tr>
              <th width="100px">규칙명</th>
              <td>{target.RuleName}</td>
            </tr>
            <tr>
              <th>조건 타입</th>
              <td>{target.ConditionType}</td>
            </tr>
            <tr>
              <th>조건 연산자</th>
              <td>{target.ConditionOperator}</td>
            </tr>
            <tr>
              <th>조건 값</th>
              <td>{target.ConditionValue}</td>
            </tr>
            <tr>
              <th>활성 여부</th>
              <td>{target.IsActive ? '활성' : '비활성'}</td>
            </tr>
            <tr>
              <th>알림 대상</th>
              <td>
                <div className='flex align-center gap-2'>
                  <TargetIcon color='var(--gray-600)' width={20} height={20} />  
                  <p className='text-b2-400 text-gray-600'>{target.NotificationTargets.length}</p>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div className="modal-footer">
          <button className="btn btn-primary big-btn w-full" onClick={handleDelete} disabled={isPending}>{isPending ? '삭제중...' : '삭제'}</button>
        </div>
      </div>
    </div>
  )
}

export default AlertSetUpDeleteModal